// here will be where sports matches will be collected through the api.
import { supabase } from "../supabaseClient";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOCALSTORAGE } from "../Config";
import { Loader } from "../Pages";
import formatGameTime from "./formatGameTime";
import LiveGameStatsModal from "../Components/modals/LiveGameStatsModal.jsx";

const TodaysGames = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [todaysGameArr, setTodaysGameArr] = useState([]);
  const [statsGame, setStatsGame] = useState(null);


  const actionBtnOne = (
    game_ID,
    gameTitle,
    gameTime,
    gameDay,
    homeLogo,
    awayLogo
  ) => {
    const gameDetails = {
      game_ID,
      gameTitle,
      gameTime,
      gameDay,
      homeLogo,
      awayLogo,
      sportType: "NHL",
    };
    localStorage.setItem(
      LOCALSTORAGE.SELECTEDGAME,
      JSON.stringify(gameDetails)
    );
    const fetchUser = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      if (sessionData?.session?.user) {
        navigate("/betPage");
      }
      else{alert("Please login to bet")}
    };
    fetchUser();

  };



  // Create Game Cards
  const createGameCard = (
    game_ID,
    gameTitle,
    gameTime,
    gameDay,
    homeLogo,
    awayLogo,
    isFinal,
    awayScore,
    homeScore
  ) => {
    return (
      <div key={game_ID} className="col-3 card m-1 seasonal-sport-card position-relative" style={{ width: "20rem", opacity: isFinal ? 0.5 : 1 }}>
        <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
        <span className="seasonal-sport-card__lights" aria-hidden="true">
          {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
        </span>
        <div className="card-body">
          <button
            type="button"
            className="btn btn-sm btn-primary position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center rounded-circle p-0"
            style={{ zIndex: 2, width: 34, height: 34 }}
            aria-label={`View ${gameTitle} game statistics`}
            title="Game statistics"
            onClick={() => setStatsGame({ gameId: game_ID, title: gameTitle })}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 3v18h18" />
              <rect x="7" y="13" width="3" height="5" fill="currentColor" stroke="none" />
              <rect x="12" y="9" width="3" height="9" fill="currentColor" stroke="none" />
              <rect x="17" y="6" width="3" height="12" fill="currentColor" stroke="none" />
              <path d="M6 10l5-4 4 2 5-5" />
            </svg>
          </button>
          <h5 className="card-title">{gameTitle}</h5>
          <div className="row">
            <div className="col">
              <img src={awayLogo} alt="Away Team Logo"
              className="img-fluid"></img>
            </div>
            <div className="col">
              <img src={homeLogo} alt="Home Team Logo"  className="img-fluid"/>
            </div>
          </div>
          <p>
            {gameDay} at {formatGameTime(gameTime)}
          </p>
          {isFinal && Number.isFinite(awayScore) && Number.isFinite(homeScore) && (
            <p className="mb-2 fw-bold" aria-label={`Final score: ${gameTitle} ${awayScore} to ${homeScore}`}>
              Final: {awayScore} – {homeScore}
            </p>
          )}

          <div className="row">
            <div className="col">
              <button
                onClick={() =>
                  actionBtnOne(
                    game_ID,
                    gameTitle,
                    gameTime,
                    gameDay,
                    homeLogo,
                    awayLogo
                  )
                }
                className="btn btn-outline-primary w-75"
                disabled={isFinal}
                title={isFinal ? "This game has ended" : undefined}
              >
                {isFinal ? "Game Over" : "Bet Friends"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const fetchData = async () => {
    setLoading(true);
    const apiUrl = `https://friendly-bets-back-end.vercel.app/api/now`;
    try {
      const response = await fetch(apiUrl);
      const games = await response.json();
      let gamesHTMLObj = [];
      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      const todayStr = today.toISOString().slice(0, 10);

      const todaysGames = games.gameWeek.find((day) => day.date === todayStr);

      if (todaysGames) {
        todaysGames.games.forEach((game) => {
          const awayTeamID = game.awayTeam.abbrev;
          const homeTeamID = game.homeTeam.abbrev;
          const homeLogo = game.homeTeam.logo;
          const awayLogo = game.awayTeam.logo;
          const game_ID = game.id;
          const gameTitle = `${awayTeamID} vs ${homeTeamID}`;
          const gameTime = game.startTimeUTC;
          const gameDay = todaysGames.dayAbbrev;
          const isFinal = game.gameState === "OFF" || game.gameState === "FINAL";
          gamesHTMLObj.push(
            createGameCard(
              game_ID,
              gameTitle,
              gameTime,
              gameDay,
              homeLogo,
              awayLogo,
              isFinal,
              game.awayTeam.score,
              game.homeTeam.score
            )
          );
        });
      }
      setTodaysGameArr(gamesHTMLObj);
    } catch (error) {
      console.error("Error fetching live games:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="text-white text-center">
      <h1>Todays Games</h1>
      {loading ? (
        <Loader />
      ) : todaysGameArr.length > 0 ? (
        <div className="row justify-content-center">{todaysGameArr}</div>
      ) : (
        <div>No games today</div>
      )}
      <LiveGameStatsModal
        show={!!statsGame}
        onClose={() => setStatsGame(null)}
        gameId={statsGame?.gameId}
        title={statsGame?.title ?? ""}
      />
    </div>
  );
};

export default TodaysGames;

const LiveGames = () => {
  const [liveGamesArr, setLiveGamesArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statsGame, setStatsGame] = useState(null);
  const navigate = useNavigate();
  const actionBtnOne = (game) => {
    const gameDetails = {
      game_ID: game.id,
      gameTitle: `${game.awayTeam.abbrev} vs ${game.homeTeam.abbrev}`,
      gameTime: game.startTimeUTC,
      gameDay: game.startTimeUTC,
      homeLogo: game.homeTeam.logo,
      awayLogo: game.awayTeam.logo,
      sportType: "NHL",
    };
    localStorage.setItem(
      LOCALSTORAGE.SELECTEDGAME,
      JSON.stringify(gameDetails)
    );
    navigate("/betPage");
  };

  const fetchLiveGames = async () => {
    setLoading(true);
    const apiUrl = `https://friendly-bets-back-end.vercel.app/api/score`;
    try {
      const response = await fetch(apiUrl);
      const allGames = await response.json();
      const liveGames = allGames.games.filter(
        (game) => game.gameState === "LIVE" || game.gameState === "CRIT"
      );

      if (liveGames.length > 0) {
        setLiveGamesArr(liveGames);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching live games:", error);
    }
  };

  useEffect(() => {
    fetchLiveGames();
  }, []);

  return (
    <div className="text-white text-center">
      <h1>Live Games</h1>
      {loading ? (
        <Loader />
      ) : (
        <div className="row justify-content-center">
          {liveGamesArr.length > 0 ? (
            liveGamesArr.map((game, index) => (
              <div
                key={index}
                className="col-3 card m-1 seasonal-sport-card"
                style={{ width: "20rem" }}
              >
                <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
                <span className="seasonal-sport-card__lights" aria-hidden="true">
                  {Array.from({ length: 16 }, (_, i) => <i key={i} />)}
                </span>
                <div className="card-body">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center rounded-circle p-0"
                    style={{ zIndex: 2, width: 34, height: 34 }}
                    aria-label="View live stats"
                    title="Live stats"
                    onClick={() => setStatsGame(game)}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M3 3v18h18" />
                      <rect x="7" y="13" width="3" height="5" fill="currentColor" stroke="none" />
                      <rect x="12" y="9" width="3" height="9" fill="currentColor" stroke="none" />
                      <rect x="17" y="6" width="3" height="12" fill="currentColor" stroke="none" />
                      <path d="M6 10l5-4 4 2 5-5" />
                    </svg>
                  </button>
                  <h5 className="card-title">
                    {game.awayTeam.abbrev} vs {game.homeTeam.abbrev}
                  </h5>
                  <div className="row">
                    <div className="col">
                      <img
                        src={game.awayTeam.logo}
                        alt={`${game.awayTeam.abbrev} logo`}
                        className="img-fluid"
                      />
                    </div>
                    <div className="col">
                      <img
                        src={game.homeTeam.logo}
                        alt={`${game.homeTeam.abbrev} logo`}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <p>{game.awayTeam.score}</p>
                    </div>
                    <div className="col">
                      <p>{game.homeTeam.score}</p>
                    </div>
                  </div>
                  <p>
                    {game.clock.timeRemaining} Period: {game.period}
                  </p>
                  <button
                    onClick={() => actionBtnOne(game)}
                    className="btn btn-outline-primary w-75"
                  >
                    Bet Friends
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>No live games currently.</p>
          )}
        </div>
      )}
      <LiveGameStatsModal
        show={!!statsGame}
        onClose={() => setStatsGame(null)}
        gameId={statsGame?.id}
        title={statsGame ? `${statsGame.awayTeam.abbrev} vs ${statsGame.homeTeam.abbrev}` : ""}
      />
    </div>
  );
};
export { LiveGames };
export { TodaysGames };
